import ResultsCount from './ResultsCount.component';

export default ResultsCount;
